<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Proyecciones de venta</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <router-link
            :to="{ name: 'ProjectionCreate' }"
            class="btn base-button btn-neutral btn-sm mt-1"
            v-text="'Nueva'"
          >
          </router-link>
          <button
            v-if="$can('charts', 'projections')"
            class="btn base-button btn-neutral btn-sm mt-1"
            @click="gotoCharts"
            v-text="'Ver Gráficas'"
          ></button>
          <router-link
            v-if="$can('statistics', 'projections')"
            :to="{ name: 'ProjectionStatistics' }"
            class="btn base-button btn-neutral btn-sm mt-1"
            v-text="'Ver Estadísticas'"
          >
          </router-link>
          <button
            v-if="campaign"
            class="btn base-button btn-neutral btn-sm mt-1"
            @click="campaign = null"
            v-text="'Cambiar Campaña'"
          ></button>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div v-if="!campaign" class="row justify-content-center">
        <div class="col-md-6 col-sm-8 col-xs-12 card-wrapper">
          <div class="card mb-4">
            <div class="card-header">
              <h3 class="mb-0">Elija la campaña para listar las proyecciones</h3>
            </div>
            <div class="card-body">
              <campaign-select v-model="campaign" />
            </div>
          </div>
        </div>
      </div>

      <div v-if="campaign && !goingToCharts">
        <div class="row">
          <div class="col">
            <projections-table :filter-campaign="campaign" :distributor="distributorId" :title="title" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import ProjectionsTable from './List/ProjectionsTable';
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import { mapActions } from 'vuex';

export default {
  components: {
    ProjectionsTable,
    RouteBreadCrumb,
    CampaignSelect,
  },

  data() {
    return {
      title: 'Proyecciones',
      distributorId: null,
      distributor: null,
      campaign: null,
      variety: null,
      goingToCharts: false,
    };
  },

  created() {
    this.distributorId = +this.$route.params.id;
    this.campaign = +this.$route.query.campaign;
    this.variety = +this.$route.query.variety;
    this.fetchDistributor();
  },

  methods: {
    ...mapActions('charts', ['setDistributor']),
    fetchDistributor() {
      this.$services
        .resource('distributors')
        .show(this.distributorId)
        .then((res) => res.data.data)
        .then((distributor) => {
          this.distributor = distributor;
        });
    },

    gotoCharts() {
      this.$router.push({ name: 'ProjectionCharts' });
      // TODO remover cuando se utilice el active filters en todas las tablas.
      this.goingToCharts = true;
      this.setDistributor(this.distributor);
    },
  },
};
</script>
